import {  Text } from "react-native";
import { useCallback, useMemo, useState } from "react";
import { EnTetePageProps } from "./EnTetePage.types";
import SelecteurPeriode from "./SelecteurPeriode";
import dayjs from 'dayjs';
import styles from './EnTetePage.styles';

export default function useEnTetePage({ text, periodGestion }: EnTetePageProps){
    const { defaultDate, period } = periodGestion || {};
    const [currentDate, setCurrentDate] = useState(dayjs(defaultDate))
    const dateDebutRef = useMemo(() => currentDate.startOf(period || "day"), [currentDate, period])
    const dateFinRef = useMemo(() => currentDate.endOf(period || "day"), [currentDate, period])
    const goToNext = useCallback(() => {
        setCurrentDate((oldDate) => oldDate.add(1, period))
    }, [period])
    const goToPrevious = useCallback(() => {
        setCurrentDate((oldDate) => oldDate.subtract(1, period))
    }, [period])


    const EnTete = useMemo(() => (
        <>
            <Text style={styles.pageTitle}>{text}</Text>
            {periodGestion && (
                <SelecteurPeriode
                    periodGestion={periodGestion}
                    currentDate={currentDate}
                    dateDebutRef={dateDebutRef}
                    dateFinRef={dateFinRef}
                    goToNext={goToNext}
                    goToPrevious={goToPrevious}
                />
            )}
        </>
    ), [currentDate, dateDebutRef, dateFinRef, goToNext, goToPrevious, periodGestion, text])

    return({ EnTete, currentDate, dateDebutRef, dateFinRef })
}
